@if (history?.length > 0) {
  @for (item of history; track item; let isLast = $last) {
    <div class="grid-x">
      <div class="cell small-4 bold">{{item?.eventDate | date: 'short'}}</div>
      <div class="cell small-8 bold">
        {{item?.changedByUserName}}
      </div>
      <div class="cell small-12 padding-left" [innerHTML]="item?.description"></div>
      @if (!isLast) {
        <div class="cell small-12">
          <hr />
        </div>
      }
    </div>
  }
} @else {
  <p>No recorded issues events.</p>
}
